import React, { useEffect, useState } from 'react'
import { useMutation, useQuery } from '@apollo/client'
import { toastSweetAlert } from '../../../../Helpers/ToastSweetAlert'
import Box from '../../../../Global/Box'
import CategoryFilter from './CategoryFilter'
import ActivityTimeline from './ActivitiTimeLine'
import { GET_LAST_ONES_TIMELINES } from '../../../../../graphql/Catalog/Timeline/timelines'
import {
  GET_ACTIVITY_FOR_ROLE_ATENCION_CIUDADANA,
  GET_ACTIVITY_REPORTS_COUNTERS,
} from '../../../../../graphql/Document/DashboardActivityByRol/dashboardActivityByRol'
import { GET_ALL_GROUPS_CATEGORIES_BY_IDS } from '../../../../../graphql/Catalog/Groups/groupsCategories'
import KpiGraphics from './KpiGraphics'
import { GET_ALL_STATUS } from '../../../../../graphql/Catalog/Status/status'
import { GET_REQUIRE_ATTENTION_REPORTS } from '../../../../../graphql/Catalog/Reports/reports'
import ActivitiAttentionReports from './ActivitiAttentionReports'
import { GET_ALL_GROUPS_CATEGORIES_SUBS_BY_CATEGORY_ID } from '../../../../../graphql/Catalog/Groups/groupsCategoriesSubs'
import KpiCustomGraphicBar from './KpiCustomGraphicBar'
import DatePickerInput from '../../../../Global/DatePickerInput'

const DashboardAtencionCiudadana = () => {
  //STATES
  const [timeline, setTimeline] = useState({
    require_attention: [],
    latest: [],
  })
  const [counter, setCounter] = useState(null)
  const [filters, setFilters] = useState({
    array_group_category_id: null,
    start_date: null,
    end_date: null,
    own_reports: false,
  })
  const [categories, setCategories] = useState([])
  const [statusIds, setStatusIds] = useState([])
  const [categoriesSubs, setCategoriesSubs] = useState([])

  //QUERIES
  const {
    data: dataCounters,
    loading: loadingCounters,
    error: errorCounters,
    refetch: refetchCounters,
  } = useQuery(GET_ACTIVITY_FOR_ROLE_ATENCION_CIUDADANA, {
    variables: { filters },
    fetchPolicy: 'no-cache',
  })

  const {
    data: dataTimeline,
    loading: loadingTimeline,
    error: errorTimeline,
  } = useQuery(GET_LAST_ONES_TIMELINES, {
    variables: { category: ['reports'], limit: 10 },
    fetchPolicy: 'no-cache',
  })

  // const {
  //   data: dataRequireAttentionReports,
  //   loading: loadingRequireAttentionReports,
  //   error: errorRequireAttentionReports,
  // } = useQuery(GET_REQUIRE_ATTENTION_REPORTS, {
  //   variables: {
  //     limit: 10,
  //     statusIds: [2, 3, 4, 5, 6, 8, 9, 13, 14, 41, 1, 38, 39, 40],
  //   }, //todos menos solucionado y cancelado
  //   fetchPolicy: 'no-cache',
  // })

  const {
    data: dataCategories,
    loading: loadingCategories,
    error: errorCategories,
  } = useQuery(GET_ALL_GROUPS_CATEGORIES_BY_IDS, {
    fetchPolicy: 'no-cache',
  })

  const [GetGroupsCategoriesSubs] = useMutation(
    GET_ALL_GROUPS_CATEGORIES_SUBS_BY_CATEGORY_ID
  )

  const {
    data: dataStatus,
    loading: loadingStatus,
    error: errorStatus,
  } = useQuery(GET_ALL_STATUS, {
    variables: {
      type: 'Reports',
      getOwnStatus: true,
    },
  })

  //FUNCTIONS
  const handleError = (message) => toastSweetAlert({ mode: 'error', message })

  const handleChangeCategories = async (selected) => {
    if (!selected || selected.value === null)
      return setFilters({
        ...filters,
        array_group_category_sub_id: null,
        array_group_category_id: null,
      })

    setFilters({
      ...filters,
      array_group_category_id: [selected.value],
      array_group_category_sub_id: null,
    })

    // //Load subcategories
    const { data } = await GetGroupsCategoriesSubs({
      variables: {
        getAllGroupsCategoriesSubByCategoryIdId: selected.value,
      },
    })
    if (data?.getAllGroupsCategoriesSubByCategoryId?.length === 0) {
      setCategoriesSubs([])
      return
    } else {
      let categoriesSubs = data?.getAllGroupsCategoriesSubByCategoryId?.map(
        (category) => {
          return {
            value: category.id,
            label: category.name,
          }
        }
      )
      setCategoriesSubs(categoriesSubs)
    }
  }

  const handleChangeCategoriesSubs = (selected) => {
    if (selected?.length === 0) {
      return setFilters({ ...filters, array_group_category_sub_id: null })
    }
    setFilters({
      ...filters,
      array_group_category_sub_id: selected.map((item) => item.value),
    })
  }

  //EFECTS
  useEffect(() => {
    if (!loadingTimeline) {
      if (errorTimeline) return handleError(errorTimeline.message)
      setTimeline({
        // require_attention:
        //   dataRequireAttentionReports.getRequireAttentionReports,
        latest: dataTimeline.getLastOnesTimelines,
      })
    }
  }, [
    dataTimeline,
    loadingTimeline,
    errorTimeline,
    // dataRequireAttentionReports,
    // loadingRequireAttentionReports,
    // errorRequireAttentionReports,
  ])

  useEffect(() => {
    try {
      if (loadingCounters) return
      if (errorCounters) return handleError(errorCounters.message)
      let dataOptions = {
        responsive: true,
        plugins: {
          legend: {
            display: true,
            position: 'bottom',
            labels: {
              font: {
                color: '#4B5563',
                size: 14,
              },
            },
          },
          datalabels: {
            // anchor: 'end',
            // align: 'start',
            color: (value) => {
              if (value.dataset.label.includes('Generados')) {
                return '#000'
              } else if (value.dataset.label.includes('Atendidos')) {
                return '#fff'
              }
            },
          },
          tooltip: {
            enabled: true,
            callbacks: {
              label: function (context) {
                let label = context.dataset.label || ''
                let parsed = context.parsed
                let stacks = parsed._stacks || {}
                if (label.includes('Generados')) {
                  return [
                    `${label}: ${stacks.y[0]}`,
                    `Atendidos: ${stacks.y[1]}`,
                  ]
                }
                if (label.includes('Atendidos')) {
                  return [
                    `${label}: ${stacks.y[1]}`,
                    `Generados: ${stacks.y[0]}`,
                  ]
                }
              },
            },
          },
        },
        scales: {
          y: {
            stacked: false,
            // display: false,
          },
          x: {
            // display: false,
            stacked: false,
            ticks: {
              color: '#4A4A4A',
              font: {
                size: 12,
                weight: 'bold',
              },
            },
          },
        },
      }

      const labelsNames =
        dataCounters?.getActivitiReportsCountersForCitizenAttention.map(
          (item) => item.name
        ) || []

      let chartData = {
        labels: labelsNames,
        datasets: [
          {
            label: 'Generados',
            data:
              dataCounters?.getActivitiReportsCountersForCitizenAttention.map(
                (item) => item.total
              ) || [],
            backgroundColor: '#F97316',
            borderColor: '#F97316',
            borderWidth: 1,
            maxBarThickness: 140,
          },
          {
            label: 'Atendidos',
            data:
              dataCounters?.getActivitiReportsCountersForCitizenAttention.map(
                (item) => item.completed
              ) || [],
            backgroundColor: '#4B5563',
            borderColor: '#4B5563',
            borderWidth: 1,
            maxBarThickness: 140,
          },
        ],
      }

      setCounter({
        barDataStatus: chartData,
        barDataOptions: dataOptions,
      })
    } catch (error) {
      return handleError(error.message)
    }
  }, [dataCounters, loadingCounters, errorCounters, refetchCounters])

  useEffect(() => {
    if (!loadingCategories) {
      if (errorCategories) return handleError(errorCategories.message)
      if (dataCategories?.categories.length === 0) {
        setCategories([])
        return
      }

      let categories = [
        {
          value: null,
          label: 'Todas las categorías',
        },
      ]
      dataCategories?.categories?.map((category) => {
        categories.push({
          value: category.id,
          label: category.name,
        })
      })

      setCategories(categories)
    }
  }, [dataCategories, loadingCategories, errorCategories])

  useEffect(() => {
    if (!loadingStatus) {
      if (errorStatus) return handleError(errorStatus.message)
      let listStatus = []
      dataStatus?.getAllCatalogStatus?.rows
        .filter((status) => status.id !== 7 && status.id !== 15)
        ?.map((status) => {
          listStatus.push(status.id)
        })
      setStatusIds(listStatus)
    }
  }, [dataStatus, loadingStatus, errorStatus])

  const handleFilters = (e, type) => {
    // setFilters({
    //   ...filters,
    //   [type]: type === 'own_reports' ? e.target.checked : e.target.value,
    // })
    setFilters((prevFilters) => ({
      ...prevFilters,
      [type]: type === 'own_reports' ? e.target.checked : e.target.value,
    }))
  }

  return (
    <>
      <Box
        classNameHeader="mt-3"
        contentHeader={
          <>
            <div className="row mb-3">
              <div className="col-lg-3">
                <h3 className="card-title pl-3 mt-0">
                  Indicadores Atención Ciudadana
                </h3>
              </div>
              <div className="col-lg-3">
                <label className="d-flex justify-content-start align-items-center m-0">
                  <div className="checkbox mr-2">
                    <input
                      type="checkbox"
                      // checked={filters.evidence}
                      onChange={(e) => handleFilters(e, 'own_reports')}
                      className="switch-filter mt-1"
                    />
                  </div>
                  <span>Mis reportes</span>
                </label>
              </div>
            </div>
            <div className="row col-12 d-flex flex-wrap pl-3 mr-3">
              {/* <div className="col-lg-3 mt-2"> */}

              {/* </div> */}
              <div className="col-lg-3">
                <label htmlFor="start_date">Fecha de inicio</label>
                <DatePickerInput
                  id="start_date"
                  name="filterRangeDateFrom"
                  type="date"
                  className="input-field form-control position-searchInput"
                  onChange={(e) => handleFilters(e, 'start_date')}
                />
              </div>
              <div className="col-lg-3">
                <label htmlFor="end_date">Fecha de fin</label>
                <DatePickerInput
                  id="end_date"
                  name="filterRangeDateFrom"
                  type="date"
                  className="input-field form-control position-searchInput"
                  onChange={(e) => handleFilters(e, 'end_date')}
                />
              </div>
            </div>
          </>
        }
        content={
          <>
            <CategoryFilter
              placeholder="Todas las categorías"
              options={categories}
              onChange={handleChangeCategories}
              isMulti={false}
            />
            {filters?.array_group_category_id && (
              <CategoryFilter
                options={categoriesSubs}
                onChange={handleChangeCategoriesSubs}
                titleContent={
                  <label>
                    Subcategorias{` `}
                    <small>
                      (Puedes filtrar, selecciona una o varias opciones)
                    </small>
                  </label>
                }
                showValue={true}
                value={filters?.array_group_category_sub_id
                  ?.map((subId) => {
                    const match = categoriesSubs.find(
                      (sub) => sub.value === subId
                    )
                    return match
                      ? { label: match.label, value: match.value }
                      : null
                  })
                  .filter(Boolean)}
              />
            )}
            {counter && (
              <KpiCustomGraphicBar
                barDataStatus={counter.barDataStatus}
                barOptions={counter.barDataOptions}
              />
            )}
          </>
        }
      />

      {/* <ActivitiAttentionReports
        reports={timeline?.require_attention}
        loading={loadingRequireAttentionReports}
        statusIds={statusIds}
      /> */}
      <ActivityTimeline
        timeline={timeline?.latest}
        loading={loadingTimeline}
        hideButton
      />
    </>
  )
}

export default DashboardAtencionCiudadana
